import React from "react";
import ReactDOM from "react-dom";
import { HashRouter, Route, Switch,Redirect  } from "react-router-dom";

import "assets/css/nucleo-icons.css";
import "assets/scss/blk-design-system-react.scss?v=1.1.0";
import "assets/demo/demo.css";

// import Index from "views/Index.js";
import LandingPage from "views/examples/LandingPage.js";
// import ProfilePage from "views/examples/ProfilePage.js";

import HomePage from "views/examples/index.js";
import RegisterPage from "views/examples/RegisterPage";

ReactDOM.render(
  <HashRouter>
    <Switch>
      {/* <Route exact path="/components" render={props => <Index {...props} />} /> */}
      <Route
        exact
        path="/"
        render={props => <HomePage {...props} />}
      />
      <Route
        exact
        path="/editor"
        render={props => <LandingPage {...props} />}
      />
      <Route
        exact
        path="/report"
        render={props => <RegisterPage {...props} />}
      />
      {/* <Route
        exact
        path="/profile-page"
        render={props => <ProfilePage {...props} />}
      /> */}
      <Route render={() => <Redirect to={{pathname: "/"}} />} />
    </Switch>
  </HashRouter>,
  document.getElementById("root")
);
